import { SPage } from "servisofts-component";

import root from "./root";
export default SPage.combinePages("ajustes",
    {
        "": root,

    }
)